module.exports = __webpack_public_path__ + "img/review-full-1.77640b9a.svg";